import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { Pivotv2Component } from './pivotv2.component';

const routes: Routes = [{ path: '', component: Pivotv2Component }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class Pivotv2RoutingModule { }
